export default {
    Cancel: '取消',
    CheckAll: '全选',
    Confirm: '确定',
    HasBeenselected: '已选择：',
    NoInformations: '没有匹配到相关信息',
    Orgs: '个部门',
    ResultNum: '条结果',
    SearchOrgUserRole: '搜索组织、姓名',
    SearchResult: '搜索结果',
    SelectOrg: '选择部门',
    SelectUser: '选择联系人',
    Subordinate: '下级',
    TurnBack: '根目录',
    UserAndOrg: '选择部门/联系人',
    Users: '个人',
    SearchOrg: '搜索组织',
    SearchNameAccount: '搜索姓名/账号'
};
